import { graphql, useStaticQuery } from 'gatsby';

export const useHomepageStaticData = () => {
  const { homepageJson } = useStaticQuery(
    graphql`
      query {
        homepageJson {
          homepage {
            headerGroupTiles {
              title
              link {
                linkedPage {
                  slug
                  parentPage {
                    name
                    slug
                    parentPage {
                      name
                      slug
                    }
                  }
                }
              }
              image {
                name
              }
              description
            }
            intakeCard {
              title
              ctaPrimaryLink {
                icon
                iconPosition
                label
                linkedPage {
                  slug
                  parentPage {
                    slug
                  }
                }
                type
                name
              }
              body {
                raw
              }
              animation {
                file {
                  url
                }
              }
            }
          }
        }
      }
    `
  );
  return homepageJson.homepage;
};
